import { createSlice } from "@reduxjs/toolkit";

// 初始状态
const initialState = {
  count: 0,
};

// 创建切片
export const counterSlice = createSlice({
  name: "counter", // 切片名称（唯一）
  initialState,
  reducers: {
    // 增加计数
    increment: (state) => {
      state.count += 1; // Redux Toolkit 内置 Immer，可直接修改状态（无需手动拷贝）
    },
    // 减少计数
    decrement: (state) => {
      state.count -= 1;
    },
    // 自定义步长增加
    incrementByAmount: (state, action) => {
      state.count += action.payload;
    },
  },
});

// 导出 Action Creator
export const { increment, decrement, incrementByAmount } = counterSlice.actions;

// 导出 Reducer
export default counterSlice.reducer;
